export const getOperatorRuns = (state) => {
  return state.operatorRuns;
};
